import { Instance } from 'mobx-state-tree';
import * as React from 'react';
import withTranslate, { WithTranslateProps } from '../common/WithTranslate';
import { TLCode } from '../../common/enums';
import { ColDef, ICellRendererParams } from 'ag-grid-community';
import { inject, observer } from 'mobx-react';
import BaseGridXL from '../common/grid/BaseGridXL';
import styled from '@emotion/styled';
import EditCell from '../common/grid/EditCell';
import { PharmacyAnnualReview } from '../../store/models/PharmacyAnnualReview';
import { IconNames } from '@blueprintjs/icons';
import TranslatedMessage from '../common/translation/TranslatedMessage';
import { Div } from 'glamorous';
import { Button, Classes, Dialog, Intent, InputGroup, RadioGroup, Radio } from '@blueprintjs/core';
import { Form } from 'react-final-form';
import { TextInputFormField } from '../common/form';
import { PharmacyAnnualReviewSearchCriteria } from '../../store/PharmacyAnnualReviewStore';
import SimpleTextFormContent from '../common/form/SimpleTextFormGroup';
import { PharmacyStore } from '../../store';
import Pharmacy from '../Pharmacy';

interface PrefManagerProps extends WithTranslateProps {
  pharmacyList: any;
  searchCriteria: Instance<typeof PharmacyAnnualReviewSearchCriteria>;
  onSearch: (criteria: any) => void;
  activeFilter: string;
  setActiveFilter: (filter: string) => void;
  filter: string;
  setFilterText: (filter: string) => void;
  PharmacyStore?: Instance<typeof PharmacyStore>;
}

interface PrefManagerState {
  annualReviewEdition?: Instance<typeof PharmacyAnnualReview>;
  annualReviewIsLoading?: boolean;
  secretariatId?: number;
  year?: number;
  width?: number;
}

const Container = styled.div`
  height: 100%;
  width: 100%;
  display: flex;
  flex-direction: column;
`;

const ContainerSearchForm = styled.div`
  display: flex;
  flex-direction: row;
`;
const DivLine = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
`;
const DivLeft = styled.div`
  display: flex;
  flex-direction: column;
  width: 30%;
  margin-right: 5%;
  padding-bottom: 5px;
`;
const DivCenter = styled.div`
  display: flex;
  flex-direction: row;
  padding-bottom: 5px;
  .bp3-form-content > div {
    display: flex;
    flex-direction: row;
    margin-right: 20px;
    .bp3-control {
      margin-top: 0;
      margin-right: 5px;
    }
  }
  .bp3-form-group {
    margin-bottom: 0;
  }
`;

@inject('PharmacyStore')
@observer
class PrefManager extends React.Component<PrefManagerProps, PrefManagerState> {
  state = {
    systemStatusEdition: undefined,
    annualReviewIsLoading: false,
    secretariatId: 1,
    year: 0,
    width: 90,
  } as PrefManagerState;

  columns = [
    {
      headerName: this.props.translate(TLCode.PHARMACY_Level),
      field: 'level',
      suppressMenu: true,
      width: 50,
    },
    {
      headerName: this.props.translate(TLCode.PHARMACY_ApbNr),
      field: 'apbNumber',
      suppressMenu: true,
      width: 75,
    },
    {
      headerName: this.props.translate(TLCode.PHARMACY),
      field: 'name',
    },
    {
      headerName: this.props.translate(TLCode.PHARMACY_PrefDayOff),
      field: 'prefDutyDayOff',
      width: 100,
    },
    {
      headerName: this.props.translate(TLCode.PHARMACY_PrefDayOn),
      field: 'prefDutyDayOn',
      width: 100,
    },
  ] as ColDef[];

  buildGridData = () => {
    const { activeFilter } = this.props;
    return this.props.pharmacyList
      .filter((elem) => {
        let show = true;
        if (activeFilter === 'three' && (elem.level == null || elem.level !== 3)) {
          show = false;
        } else if (activeFilter === 'one' && (elem.level == null || elem.level !== 1)) {
          show = false;
        }
        return show;
      })
      .map((p) => ({
        pharmacyId: p.pharmacyId,
        level: p.level,
        apbNumber: p.apbNumber,
        name: p.name,
        prefDutyDayOff: p.prefDutyDayOff,
        prefDutyDayOn: p.prefDutyDayOn,
      }));
  };

  handleCalculate = () => {};

  onChangeYear = (data) => {
    this.setState({ year: data });
  };

  onChangeStatusCriterion = (data) => {
    // this.props.searchCriteria.status = data;
    this.props.setActiveFilter(data);
  };

  render() {
    const { annualReviewEdition } = this.state;
    const { setFilterText, filter, setActiveFilter, activeFilter, translate } = this.props;
    return (
      <Container>
        <Form onSubmit={this.props.onSearch} initialValues={this.props.searchCriteria}>
          {({ handleSubmit, mutators, initialize }) => (
            <div>
              {/* <ContainerSearchForm>
                <DivLine>
                  <DivCenter>
                    <SimpleTextFormContent label={TLCode.PHARMACY_Level}>
                      <RadioGroup
                        selectedValue={activeFilter}
                        onChange={(data) => this.onChangeStatusCritersion(data.currentTarget.value)}
                      >
                        <Radio
                          key={'one'}
                          label={'1'}
                          value="one"
                          alignIndicator="right"
                        />
                        &nbsp;&nbsp;&nbsp;
                        <Radio
                          key={'three'}
                          label={'3'}
                          value="three"
                          alignIndicator="right"
                        />
                        &nbsp;&nbsp;&nbsp;
                        <Radio
                          key={'All'}
                          label={'tous'}
                          value="both"
                          alignIndicator="right"
                        />
                        &nbsp;&nbsp;&nbsp;
                      </RadioGroup>
                    </SimpleTextFormContent>
                  </DivCenter>
                </DivLine>
                &nbsp;&nbsp;
                <div style={{ marginLeft: '20px' }}>
                  <Button intent="primary" icon={IconNames.SEARCH} onClick={() => handleSubmit()}>
                    <TranslatedMessage id={TLCode.GENERAL_Search} />
                  </Button>
                </div>
                &nbsp;&nbsp;
                <InputGroup placeholder="Year to review..." onChange={(e) => this.onChangeYear(e.target.value)} />
              </ContainerSearchForm> */}
              <DivLine>
                <DivLeft>
                  <InputGroup
                    placeholder="Filter..."
                    leftIcon="search"
                    value={filter}
                    onChange={(e) => setFilterText(e.target.value)}
                  />
                </DivLeft>
              </DivLine>
            </div>
          )}
        </Form>
        <BaseGridXL
          columnDefs={this.columns}
          rowData={this.buildGridData()}
          keyName={'pharmacyId'}
          quickFilterText={filter}
        />
        {/* <Dialog
          isOpen={annualReviewEdition !== undefined}
          onClose={this.stopEdition}
          icon={IconNames.EDIT}
          title={<TranslatedMessage id={TLCode.SECRETARIAT_DASHBOARD_ANNUAL_REVIEW_Validate} />}
        >
          {annualReviewEdition && (
            <Div>
              <div className={Classes.DIALOG_BODY}>
                <Form
                  initialValues={annualReviewEdition}
                  onSubmit={this.save}
                  render={({ handleSubmit, hasValidationErrors, dirty }) => {
                    return (
                      <form onSubmit={handleSubmit}>
                        <TextInputFormField
                          name="actualDutyCount"
                          label={TLCode.SECRETARIAT_DASHBOARD_ANNUAL_REVIEW_ActualDutyCount}
                          inline={true}
                          fill={true}
                          disabled={true}
                        />
                        <TextInputFormField
                          name="averageDutyCount"
                          label={TLCode.SECRETARIAT_DASHBOARD_ANNUAL_REVIEW_AverageDutyCount}
                          inline={true}
                          fill={true}
                          disabled={true}
                        />
                        <TextInputFormField
                          name="approvedBalance"
                          label={TLCode.SECRETARIAT_DASHBOARD_ANNUAL_REVIEW_Balance}
                          inline={true}
                          required={true}
                          fill={true}
                          autoFocus={true}
                        />
                        <div className={Classes.DIALOG_FOOTER}>
                          <div className={Classes.DIALOG_FOOTER_ACTIONS}>
                            <Button
                              text={<TranslatedMessage id={TLCode.GENERAL_Cancel} />}
                              onClick={this.stopEdition}
                            />
                            <Button
                              type="submit"
                              intent={Intent.PRIMARY}
                              disabled={hasValidationErrors}
                              text={<TranslatedMessage id={TLCode.SECRETARIAT_DASHBOARD_ANNUAL_REVIEW_Validate} />}
                            />
                          </div>
                        </div>
                      </form>
                    );
                  }}
                />
              </div>
            </Div>
          )}
        </Dialog> */}
      </Container>
    );
  }
}

export default withTranslate(PrefManager);
